import styled from 'styled-components/macro';
import { Z_INDEX } from 'styleguide';

const PopupContent = styled.div`
  position: absolute;
  z-index: ${Z_INDEX.pop_up};
`;

export default PopupContent;
